// Advances the product media slider on a fixed interval.
// Only engages where the gallery genuinely scrolls horizontally (the mobile
// slider); Dawn's desktop "stacked" layout has no horizontal axis, so the
// step measures 0 and we leave it alone.
class GalleryAutoplay {
  constructor(root) {
    this.root = root;
    this.seconds = parseFloat(root.dataset.galleryAutoplay || '0');
    this.track = root.querySelector('.product__media-list');
    if (!this.track || !this.seconds) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.paused = false;
    ['pointerenter', 'focusin', 'pointerdown', 'touchstart'].forEach((type) =>
      this.track.addEventListener(type, () => (this.paused = true), { passive: true })
    );
    ['pointerleave', 'focusout'].forEach((type) =>
      this.track.addEventListener(type, () => (this.paused = false), { passive: true })
    );
    document.addEventListener('visibilitychange', () => (this.paused = document.hidden));

    this.timer = window.setInterval(() => this.tick(), this.seconds * 1000);
  }

  get step() {
    const slides = this.track.querySelectorAll('.product__media-item');
    if (slides.length < 2) return 0;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  }

  tick() {
    if (this.paused) return;
    const step = this.step;
    if (!step) return; // stacked/desktop layout - nothing to advance

    const max = this.track.scrollWidth - this.track.clientWidth;
    let next = this.track.scrollLeft + step;
    if (next > max - 2) next = 0; // wrap back to the first photo
    this.track.scrollTo({ left: next, behavior: 'smooth' });
  }
}

const startGalleryAutoplay = () =>
  document.querySelectorAll('[data-gallery-autoplay]').forEach((el) => new GalleryAutoplay(el));

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startGalleryAutoplay);
} else {
  startGalleryAutoplay();
}
